<template>
  <div class="payment section container">
    <h3>{{ $t('payment.2DatosDePago') }}</h3>
    <b-form @submit.prevent="checkPaymentData">
      <b-row class="no-gutters">
        <b-col cols="12" md="6" class="container-purchase-card">
          <div
            v-if="paymentMethods.telecoming && showTelecoming"
            class="container-payment-methods"
          >
            <button
              type="button"
              class="btn"
              :class="{
                'w-active':
                  type === 'card' ||
                  type === 'three_ds' ||
                  type === 'stripe' ||
                  type === 'stripe_3ds'
              }"
              @click="changePaymentType('card|stripe')"
            >
              <img
                :src="require('@/assets/images/ic-card-white.svg')"
                class="payment-method-image"
                alt=""
              />
              {{ $t('payment.pagarConTarjeta') }}
            </button>
            <button
              v-if="paymentMethods.telecoming && showTelecoming"
              type="button"
              class="btn"
              :class="{ 'w-active': type === 'telecoming' }"
              @click="changePaymentType('telecoming')"
            >
              <img
                :src="require('@/assets/images/ic_mobile_white.svg')"
                class="payment-method-image telecoming"
                alt=""
              />
              {{ $t('payment.pagarConMovil') }}
            </button>
          </div>
          <div
            v-if="
              type === 'card' ||
                type === 'three_ds' ||
                type === 'stripe' ||
                type === 'stripe_3ds'
            "
          >
            <div
              v-if="
                telecoming &&
                  !telecoming.mobileData.success &&
                  telecoming.carrier.complete_url
              "
            >
              <p class="m0 mB20">
                {{ $t('payment.falloTelecoming') }}
              </p>
            </div>
            <div
              v-if="
                paymentMethods.reuse && userCards.length > 0 && type === 'card'
              "
            >
              <div class="container-saved-user-cards">
                <div v-on-clickaway="clickAwayCards" class="container-selector">
                  <div
                    :class="{ 'open-selector': showSelectorCards }"
                    class="select-card"
                    @click="showSelectorCards = !showSelectorCards"
                  >
                    <span v-if="cardId" class="selected">
                      {{ truncateCardNumber(selectedCard.number) }}
                    </span>
                    <span v-else class="selected">
                      {{ $t('card.seleccionaUnaTarjeta') }}
                    </span>
                  </div>
                  <ul v-show="showSelectorCards" class="selector cards">
                    <li
                      v-for="(card, index) in userCards"
                      :key="index"
                      :class="{ selected: selectedCard.id === card.id }"
                      @click="selectCard(card)"
                    >
                      <p class="title">
                        {{ truncateCardNumber(card.truncated) }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-if="userCards.length > 0" class="add-new-card-text">
              <p
                v-show="!addNewCard"
                class="cP tAl text-topaz"
                @click="addCard()"
              >
                {{ $t('payment.añadirTarjetaNueva') }}
              </p>
              <p
                v-show="addNewCard && userCards.length > 0"
                class="cP tAl text-topaz"
                @click="noAddCard()"
              >
                {{ $t('payment.noAñadirTarjetaNueva') }}
              </p>
            </div>

            <!-- TODOS -->
            <credit-card
              v-if="addNewCard && type !== 'stripe_3ds'"
              class="payment-credit-card"
              :card="card"
              :valid-card.sync="validCard"
              :valid-cvc.sync="validCvc"
              :valid-date.sync="validDate"
              :valid-name.sync="validName"
              :type.sync="card.cardType"
            />
            <!-- STRIPE 3DS -->
            <credit-card-stripe
              v-if="addNewCard && type === 'stripe_3ds'"
              class="payment-credit-card"
              :card="card"
              :valid-name.sync="validName"
            />
            <div
              v-if="
                type === 'card' &&
                  !noSaveCard &&
                  addNewCard &&
                  $store.state.user.detail.id &&
                  !$store.state.purchase.detail.buyer
              "
              class="mT5"
            >
              <b-form-group id="new-card">
                <b-form-checkbox id="new-card-checkbox" v-model="card.save">
                  <span>{{ $t('payment.guardarTarjeta') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
          <div
            v-if="
              type === 'card' &&
                event.insurance &&
                !$store.state.purchase.detail.buyer
            "
          >
            <insurance
              :insurance-data.sync="insuranceData"
              :there-is-insurance.sync="thereIsInsurance"
              :insurance-premium="purchase.insurance_premium"
              @openInsuranceModal="openModalInsurance"
              @removeInsurance="removeInsurance"
            />
          </div>
          <div v-if="type === 'telecoming'">
            <iframe
              v-if="telecoming.carrier.complete_url"
              id="telecoming-iframe"
              style="width: 1px; height: 1px;"
              frameBorder="0"
              :src="telecoming.carrier.complete_url"
            />
            <div v-if="!termsAccepted" class="tAc">
              <p
                class="mT20 mB20"
                v-html="$t('payment.telecomingTerminosCondiciones')"
              />
              <p class="mT20 mB20">{{ $t('payment.telecomingAviso3g') }}</p>
              <button
                type="button"
                class="btn opacity mB20"
                :hide="type === 'card' || type === 'three_ds'"
                @click="acceptTelecomingTerms()"
              >
                {{ $t('payment.aceptar') }}
              </button>
            </div>
            <div
              v-else-if="telecoming.mobileData.success && termsAccepted"
              class="tAc"
            >
              <div v-if="!telecoming.mobileData.needs_pin">
                <p
                  class="m0 mB20"
                  v-html="$t('payment.telecomingUltimoPaso')"
                />
                <span
                  v-if="telecoming.mobileData.msisdn"
                  class="mAuto span-as-input"
                >
                  {{ telecoming.mobileData.msisdn }}
                </span>
              </div>
              <div v-if="telecoming.mobileData.needs_pin">
                <p v-if="telecoming.mobileData.needs_pin" class="m0 mB20">
                  {{
                    $t(
                      'payment.porUltimoIntroduceElPINQueHasRecibidoEnTuMovilMedianteSMS'
                    )
                  }}
                </p>
                <input
                  v-model="telecoming.mobileData.pin"
                  required
                  class="mAuto"
                  type="text"
                  name=""
                />
                <p v-if="telecoming.mobileData.needs_pin" class="m0 mB20">
                  {{ $t('payment.vasAComprarConEsteMovil') }}
                </p>
                <p v-if="telecoming.mobileData.msisdn" class="m0 mB20">
                  telecoming.mobileData.msisdn
                </p>
              </div>
              <img
                v-if="telecoming.mobileData.carrier"
                class="carrier-image"
                :src="
                  require(`@/assets//images/${telecoming.mobileData.carrier}.png`)
                "
                :alt="telecoming.mobileData.carrier"
                fluid
              />
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="container-purchase-detail container-purchase-detail-payment"
        >
          <div id="purchaseDetail" class="selected">
            <div>
              <p class="detail">{{ $t('tickets.detalleDeCompra') }}</p>
              <div class="container-info">
                <div v-for="(ticket, index) in ticketsDetail" :key="index">
                  <p class="tAl info">
                    {{ ticket.quantity }}x {{ ticket.title }}
                  </p>
                  <p class="tAr info">
                    {{
                      $n(ticket.price * ticket.quantity, {
                        key: 'currency',
                        currency: purchase.currency
                      })
                    }}
                  </p>
                </div>
                <div v-if="thereIsInsurance">
                  <p class="tAl info">
                    {{ $t('payment.seguroDeNoAsistencia') }}
                  </p>
                  <p class="tAr info">
                    {{
                      $n(purchase.insurance_premium, {
                        key: 'currency',
                        currency: purchase.currency
                      })
                    }}
                  </p>
                </div>
                <p class="tAl info">{{ $t('tickets.gastosDeGestion') }}</p>
                <p class="tAr info">
                  {{
                    $n(purchase.total_commission, {
                      key: 'currency',
                      currency: purchase.currency
                    })
                  }}
                </p>
                <p class="tAl total">{{ $t('tickets.total') }}</p>
                <p class="tAr total">
                  {{
                    $n(
                      thereIsInsurance
                        ? parseFloat(purchase.total_price) +
                            parseFloat(purchase.insurance_premium)
                        : purchase.total_price,
                      { key: 'currency', currency: purchase.currency }
                    )
                  }}
                </p>
                <p class="tAr help-text">{{ $t('tickets.ivaIncluido') }}</p>
              </div>
            </div>
            <button
              v-if="
                (type === 'card' || type === 'three_ds' || type === 'reuse') &&
                  purchase.total_price >= 420
              "
              :disabled="isDisabled"
              :class="{ opacity: !isDisabled, transparent: isDisabled }"
              type="button"
              class="btn purchase"
              @click="adviseMaxPrice()"
            >
              {{ $t('tickets.comprar') }}
            </button>
            <button
              v-else-if="
                (type === 'three_ds' || type === 'stripe_3ds') &&
                  purchase.currency === 'EUR' &&
                  totalPrice >= 30
              "
              :disabled="isDisabled"
              :class="{ opacity: !isDisabled, transparent: isDisabled }"
              type="button"
              class="btn purchase"
              @click="advise3ds()"
            >
              {{ $t('tickets.comprar') }}
            </button>
            <button
              v-else
              :disabled="isDisabled"
              :class="{ opacity: !isDisabled, transparent: isDisabled }"
              class="btn purchase"
            >
              {{ $t('tickets.comprar') }}
            </button>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <insurance-modal
      v-if="openInsurance"
      :tickets="purchase.tickets"
      :insurance-data.sync="insuranceData"
      :there-is-insurance.sync="thereIsInsurance"
      :add-insurance="_addInsurance"
      @closeInsuranceModal="openInsurance = false"
    />
    <advise-max-price-modal
      v-if="showAdviseMaxPrice"
      @closeAdviseMaxPriceModal="closeAdviseMaxPrice"
      @closeAdviseMaxPriceModalPay="closeAdviseMaxPricePay"
    />
    <advise3ds
      v-if="showAdvise3ds"
      @closeAdvise3ds="closeAdvise3ds"
      @aceeptPayment="closeAdvise3dsPay"
    />
    <loader v-show="loading" class="load-more-loader" :middle="true" />
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import CreditCard from '@/components/credit-card/CreditCard.vue'
import CreditCardStripe from '@/components/credit-card-stripe/CreditCardStripe.vue'
import Insurance from '@/components/insurance/Insurance.vue'
import InsuranceModal from '@/components/insurance/InsuranceModal.vue'
import AdviseMaxPriceModal from '@/components/advise-max-price/AdviseMaxPriceModal.vue'
import Advise3ds from '@/components/advise-3ds/Advise3ds.vue'
import Loader from '@/components/loader/Loader.vue'
import { navigation } from '@/plugins/mixins/navigation'

export default {
  components: {
    CreditCard,
    CreditCardStripe,
    Insurance,
    InsuranceModal,
    Loader,
    AdviseMaxPriceModal,
    Advise3ds
  },
  mixins: [
    clickaway,
    navigation
  ],
  data: () => ({
    showTelecoming: false,
    selectedCard: {},
    addNewCard: true,
    type: '',
    noSaveCard: false,
    retry: false,
    tickets: [],
    ticketsDetail: {},
    paymentData: {},
    insuranceData: {},
    loading: false,
    openInsurance: false,
    validCard: false,
    validCvc: false,
    validDate: false,
    validName: false,
    showSelectorCards: false,
    thereIsInsurance: false,
    cardId: undefined,
    card: {},
    termsAccepted: false,
    showAdviseMaxPrice: false,
    showAdvise3ds: false
  }),
  computed: {
    event() {
      return this.$store.state.event.detail
    },
    isDisabled() {
      if (this.type === 'stripe_3ds') {
        return !(
          this.isCompleteCardNumber &&
          this.isCompleteCvc &&
          this.isCompleteExpiry
        )
      } else if (
        ((this.type === 'card' ||
          this.type === 'three_ds' ||
          this.type === 'stripe') &&
          (((!this.validCard ||
            !this.validCvc ||
            !this.validDate ||
            !this.validName) &&
            this.addNewCard &&
            typeof this.cardId === 'undefined') ||
            (!this.addNewCard && typeof this.cardId === 'undefined'))) ||
        (this.type === 'telecoming' &&
          !this.$store.state.telecoming.mobileData.success)
      ) {
        return true
      }
      return false
    },
    paymentMethods() {
      return this.$store.state.payment.methods
    },
    purchase() {
      return this.$store.state.purchase.detail
    },
    userCards() {
      return this.$store.state.user.cards
    },
    telecoming() {
      return this.$store.state.telecoming
    },
    totalPrice() {
      let totalPrice = this.purchase.total_price
      let insurancePrice = this.purchase.insurance_premium

      if (this.discountDetails && this.discountValid) {
        totalPrice = this.discountDetails.total_price_discounted
        insurancePrice = this.discountDetails.insurance_discounted
      }

      if (this.thereIsInsurance) {
        return parseFloat(totalPrice) + parseFloat(insurancePrice)
      }

      return parseFloat(totalPrice)
    }
  },
  created() {
    this.paymentData = {
      purchase: this.$store.state.purchase.detail.id
    }
    if (this.$route.query.buyer) {
      this.paymentData.buyer = this.$route.query.buyer
    }else if (this.$store.state.purchase.detail.buyer) {
      this.paymentData.buyer = this.$store.state.purchase.detail.buyer.id
    }
    this._formatTickets()
  },
  mounted() {
    if (window && window.Stripe) {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
      this.elements = this.stripe.elements()
    }
    this.addNewCard = !this.$store.state.user.cards.length > 0
    this.$on('closeInsuranceModal', () => {
      this.openInsurance = false
    })
    this._managePaymentMethods()
    this.header = document.getElementById('header')
    this.purchaseDetail = document.getElementById('purchaseDetail')
    window.addEventListener('scroll', this.handleScrollPurchaseDetail)
    this.handleScrollPurchaseDetail()
  },
  updated() {
    if (
      this.elements &&
      this.type === 'stripe_3ds' &&
      !this.cardNumberStripe &&
      document.getElementById('card-element')
    ) {
      this.handleCreateElementsStripe()
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollPurchaseDetail)
    this.purchaseDetail = undefined
    this.header = undefined
  },
  methods: {
    closeAdviseMaxPrice() {
      this.showAdviseMaxPrice = false
    },
    closeAdviseMaxPricePay() {
      this.showAdviseMaxPrice = false
      this.checkPaymentData()
    },
    closeAdvise3ds() {
      this.showAdvise3ds = false
    },
    closeAdvise3dsPay() {
      this.showAdvise3ds = false
      this.checkPaymentData()
    },
    advise3ds() {
      this.showAdvise3ds = true
    },
    adviseMaxPrice() {
      this.showAdviseMaxPrice = true
    },
    isMobile() {
      if (
        /Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
    handleScrollPurchaseDetail() {
      var deviceType = this.isMobile()
      if (
        deviceType === 'pc' &&
        this.purchaseDetail &&
        window.scrollY >
          this.purchaseDetail.parentNode.offsetTop -
            this.header.offsetHeight -
            20
      ) {
        this.purchaseDetail.classList.add('isAffixed')
      } else if (this.purchaseDetail && this.purchaseDetail.classList) {
        this.purchaseDetail.classList.remove('isAffixed')
      }
    },
    openModalInsurance() {
      this.openInsurance = true
    },
    removeInsurance() {
    },
    addCard() {
      this.addNewCard = !this.addNewCard
      this.cardId = null
      this.card = {}
    },
    noAddCard() {
      this.addNewCard = !this.addNewCard
    },
    truncateCardNumber(truncated) {
      if (truncated) {
        truncated = truncated.substring(
          truncated.lastIndexOf('*') + 1,
          truncated.length
        )
        return '**** **** **** ' + truncated
      }
      return '**** **** **** ****'
    },
    clickAwayCards() {
      if (this.showSelectorCards) this.showSelectorCards = false
    },
    changePaymentType(type) {
      if (type === 'telecoming' && !this.$store.state.telecoming.carrier)
        this._getCarrier()
      else if (type === 'card|stripe') {
         if(this.$store.state.payment.methods.three_ds) {
          this.type = 'three_ds';
        } else if (this.$store.state.payment.methods.stripe_3ds) {
          this.type = 'stripe_3ds';
        }
      } else this.type = type
    },
    async checkPaymentData() {
      if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'AddPaymentInfo', {
          content_name: this.$store.state.event.detail.title
        })
      }
      if (
        this.addNewCard &&
        (this.type === 'card' ||
          this.type === 'three_ds' ||
          this.type === 'stripe' ||
          this.type === 'stripe_3ds')
      ) {
        if (this.type === 'stripe_3ds') {
          const result = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardNumberStripe,
            billing_details: {
              // Include any additional collected billing details.
              name: this.card.name
            }
          })
          this.stripePaymentMethodHandler(result)
        } else {
          this.paymentData.details = {
            pan: this.card.number.replace(/\D/g, ''),
            expiry_year: this.card.exp_year.replace(/\D/g, ''),
            expiry_month: this.card.exp_month.replace(/\D/g, ''),
            cvv2: this.card.cvc.replace(/\D/g, ''),
            type: this.type,
            save_card: this.card.save ? this.card.save : false
          }
          this._payTickets()
        }
      } else if (
        this.cardId &&
        (this.type === 'card' || this.type === 'three_ds')
      ) {
        this.paymentData.details = {
          type: 'reuse',
          card_id: this.cardId
        }
        this._payTickets()
      } else if (this.type === 'telecoming') {
        this.paymentData.details = {
          msisdn: this.$store.state.telecoming.mobileData.msisdn,
          carrier: this.$store.state.telecoming.mobileData.carrier,
          type: 'telecoming',
          mobile_data: true
        }
        if (
          this.$store.state.telecoming.mobileData.pin &&
          this.$store.state.telecoming.mobileData.needs_pin
        ) {
          this.paymentData.details.pin = this.$store.state.telecoming.mobileData.pin
          this.paymentData.details.reference = this.$store.state.telecoming.mobileData.reference
          this.paymentData.details.type = 'telecoming_confirm'
        }
        this._payTickets()
      }
    },
    handleCreateElementsStripe() {
      const style = {
        base: {
          color: '#FFFFFF',
          fontFamily: 'Museo Sans, montserrat',
          fontSize: '16px'
        },
        invalid: {
          color: '#FFFFFF'
        }
      }
      this.cardNumberStripe = this.elements.create('cardNumber', {
        style,
        classes: { base: 'stripe-element' },
        placeholder: this.$t('payment.numeroDeTarjeta')
      })
      this.cvcStripe = this.elements.create('cardCvc', {
        style,
        classes: { base: 'stripe-element' },
        placeholder: 'CVC'
      })
      this.expiryStripe = this.elements.create('cardExpiry', {
        style,
        classes: { base: 'stripe-element' },
        placeholder: 'MM/YY'
      })
      // Add an instance of the card UI component into the `card-element` <div>
      this.cardNumberStripe.mount('#card-element')
      this.expiryStripe.mount('#expiry-element')
      this.cvcStripe.mount('#cvc-element')
      this.handleChangeElementsStripe()
    },
    handleChangeElementsStripe() {
      this.cardNumberStripe.on('change', event => {
        this.isCompleteCardNumber = event.complete
      })
      this.expiryStripe.on('change', event => {
        this.isCompleteExpiry = event.complete
      })
      this.cvcStripe.on('change', event => {
        this.isCompleteCvc = event.complete
      })
    },
    async stripePaymentMethodHandler(result) {
      if (result.error) {
        const event = new CustomEvent('showError', {
          detail: {
            textI18N: 'error.title',
            errorCode: 'error_stripe',
            text: this.$t('payment.errorStripe')
          }
        })
        window.dispatchEvent(event)
        this.loading = false
      } else {
        // Otherwise send paymentMethod.id to your server (see Step 4)
        this._payTickets()
      }
    },
    selectCard(card) {
      this.addNewCard = false
      this.selectedCard = {
        number: card.truncated,
        expiry: card.expiry_month + '/' + card.expiry_year
      }
      this.card = {
        number: this.truncateCardNumber(card.truncated),
        exp_month: card.expiry_month.toString(),
        exp_year: card.expiry_year.toString()
      }
      this.cardId = card.id
      this.showSelectorCards = false
    },
    acceptTelecomingTerms() {
      this.loading = true
      this.termsAccepted = true
      if (typeof this.$store.state.purchase.detail.buyer === 'undefined') {
        let data = {
          cloudio_terms_accepted: true
        }
        this.$store
          .dispatch('user/update', {
            user: this.$store.state.user.detail.id,
            data: data
          })
          .then(() => {
            this._getCarrier()
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this._getCarrier()
      }
    },
    _getMobileData() {
      window.addEventListener(
        'message',
        event => {
          if (event.data && event.data.telecoming_data) {
            this.$store.dispatch(
              'telecoming/getMobileData',
              event.data.telecoming_data
            )
            this._manageTelecoming()
          }
          this.loading = false
        },
        false
      )
    },
    _manageTelecoming() {
      if (!this.$store.state.telecoming.mobileData.success) {
        this.showTelecoming = false
        this.type = 'card'
      }
    },
    async _getCarrier() {
      var query = {
        purchase: this.$store.state.purchase.detail.id,
        web: true
      }
      await this.$store.dispatch('telecoming/getCarrier', query)
      var data = {
        completeUrl: this.$store.state.telecoming.carrier.complete_url,
        headers: this.$store.state.telecoming.carrier.headers
      }
      this._getMobileData()
    },
    async _payTickets() {
      this.retry = false
      this.loading = true
      await this.$store
        .dispatch('payment/create', this.paymentData)
        .then(res => {
          this._managePayment()
        })
        .catch(reason => {
          this.loading = false
          this.$store.dispatch('payment/setDefaultPayment', {
            detail:
              reason && reason.response && reason.response.data
                ? reason.response.data
                : {},
            status:
              reason && reason.response && reason.response.status
                ? reason.response.status
                : 'no status code'
          })
          if (
            reason &&
            reason.response &&
            reason.response.data &&
            reason.response.status
          ) {
            this._showPaymentError()
          } else {
            this._showPaymentError(true)
          }
        })
    },
    _checkPaymentStatus() {
      var payload = {
        query: {
          reference: this.$store.state.payment.detail.reference
        },
        params: {
          payment: this.$store.state.payment.detail.id
        }
      }
      this.$store
        .dispatch('payment/detail', payload)
        .then(res => {
          this._managePayment()
        })
        .catch(reason => {
          this.loading = false
          console.log(reason)
          this._showPaymentError()
        })
    },
    async _managePayment() {
      if (this.$store.state.payment.detail.accepted) {
        if (this.thereIsInsurance) this._manageInsurance()
        this.$ga.ecommerce.addTransaction({
          id: this.$store.state.purchase.detail.id.toString(),
          revenue: this.$store.state.purchase.detail.total_price,
          currency: this.$store.state.purchase.detail.currency,
          tax: this.$store.state.purchase.detail.total_commission.toString()
        })
        this.$ga.ecommerce.send()
        this.$ga.event(
          'purchase',
          'ecommerce',
          this.$store.state.event.detail.title,
          this.$store.state.purchase.detail.id
        )
        if (
          typeof window.ga !== 'undefined' &&
          this.$store.state.event.detail.google_pixel_js !== ''
        ) {
          window.ga('Extra.send', 'pageview')
          window.ga('Extra.ecommerce:addTransaction', {
            id: this.$store.state.purchase.detail.id.toString(),
            revenue: this.$store.state.purchase.detail.total_price,
            currency: this.$store.state.purchase.detail.currency,
            tax: this.$store.state.purchase.detail.total_commission.toString()
          })
          window.ga('Extra.ecommerce:send')
        }
        try {
          if (
            typeof window.PostAffTracker !== 'undefined' &&
            typeof window.PostAffTracker.createSale === 'function'
          ) {
            var sale = window.PostAffTracker.createSale()
            sale.setTotalCost(
              this.$store.state.purchase.detail.total_commission.toString()
            )
            sale.setOrderID(this.$store.state.purchase.detail.id.toString())
            sale.setProductID(this.$store.state.event.detail.id.toString())
            sale.setData1(this.$store.state.event.detail.title)
            window.PostAffTracker.register()
          }
        } catch (error) {
          console.log('PAP error')
        }
        if (typeof window.google_trackConversion === 'function') {
          window.google_trackConversion({
            google_conversion_id: 966208932,
            google_conversion_language: 'en',
            google_conversion_format: '3',
            google_conversion_color: 'ffffff',
            google_conversion_label: 'jIdpCKu2_nAQpNvczAM',
            google_conversion_value:
              this.$store.state.purchase.detail.currency +
              this.$store.state.purchase.detail.total_price.toString(),
            google_conversion_currency: this.$store.state.purchase.detail
              .currency,
            google_remarketing_only: false
          })
          if (
            this.$store.state.event.detail.adwords !== null &&
            this.$store.state.event.detail.adwords !== ''
          ) {
            window.google_trackConversion({
              google_conversion_id: JSON.parse(
                this.$store.state.event.detail.adwords
              ).google_conversion_id,
              google_conversion_language: 'en',
              google_conversion_format: '3',
              google_conversion_color: 'ffffff',
              google_conversion_label: JSON.parse(
                this.$store.state.event.detail.adwords
              ).google_conversion_label,
              google_conversion_value:
                this.$store.state.purchase.detail.currency +
                this.$store.state.purchase.detail.total_price.toString(),
              google_conversion_currency: this.$store.state.purchase.detail
                .currency,
              google_remarketing_only: false
            })
          }
        }
        if (typeof window.fbq !== 'undefined') {
          var tickets = []
          this.$store.state.tickets.selected.forEach((item, index) => {
            tickets = tickets.concat(
              Array.from(Array(parseInt(item.quantity)), () => {
                return { ticket_type: item.id }
              })
            )
          })
          window.fbq('track', 'Purchase', {
            content_ids: tickets,
            content_name: this.$store.state.event.detail.title,
            value: this.$store.state.purchase.detail.total_price,
            currency: this.$store.state.purchase.detail.currency
          })
        }
        this.navigateToThankYouPage(this.purchase.reference);
        this.loading = false
      } else {
        if (this.$store.state.payment.detail.retry) {
          if (
            this.$store.state.payment.detail.retry_type === 'stripe_fallback'
          ) {
            this.paymentData.details.type = this.$store.state.payment.detail.retry_type
            this.paymentData.details.save = false
            this.retry = true
            this._payTickets()
          }
        } else {
          if (
            this.$store.state.payment.detail.status === 'needs_info' &&
            !!this.$store.state.payment.detail.procedure_data &&
            !!this.$store.state.payment.detail.procedure
          ) {
            if (this.$store.state.payment.detail.procedure_data.client_secret) {
              const {
                error: errorAction,
                paymentIntent
              } = await this.stripe.handleCardAction(
                this.$store.state.payment.detail.procedure_data.client_secret
              )

              if (errorAction) {
                const event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    errorCode: 'error_stripe',
                    text: this.$t('payment.errorStripe')
                  }
                })
                window.dispatchEvent(event)
                this.loading = false
              } else {
                // The card action has been handled
                // The PaymentIntent can be confirmed again on the server
                // call _payTickets
                this.paymentData.details = {
                  payment_intent: paymentIntent.id,
                  type: 'stripe_3ds_confirm'
                }

                this._payTickets(this.$store.state.payment.detail.id)
              }
            } else if (
              this.$store.state.payment.detail.procedure === 'challenge_request'
            ) {
              const data = {
                PaReq: this.$store.state.payment.detail.procedure_data.PAReq,
                MD: this.$store.state.payment.detail.procedure_data.MD,
                TermUrl: this.buildTermUrl(this.$store.state.payment.detail.procedure_data.termURL)
              }

              this._formPost(
                this.$store.state.payment.detail.procedure_data.acsURL,
                data,
                'POST'
              )
              this.loading = false
            }
          } else {
            this.loading = false
            if (
              typeof this.$store.state.payment.detail.status !== 'undefined' &&
              this.$store.state.payment.detail.status === 'needs_info'
            ) {
              this.$store.state.telecoming.mobileData.needs_pin = true
              this.$store.state.telecoming.mobileData.reference = this.$store.state.payment.detail.reference
            } else if (
              typeof this.$store.state.payment.detail.status !== 'undefined' &&
              this.$store.state.payment.detail.status === 'pending'
            ) {
              setTimeout(function() {
                this._checkPaymentStatus(
                  this.$store.state.payment.detail.id,
                  this.$store.state.payment.detail.reference
                )
              }, 1000)
            } else if (
              typeof this.$store.state.payment.detail.status !== 'undefined' &&
              this.$store.state.payment.detail.status === 'denied' &&
              this.type === 'telecoming'
            ) {
              this.changePaymentType('card')
              this.showTelecoming = false
              this.$store.state.telecoming.mobileData.success = false
            } else {
              this._showPaymentError()
            }
          }
        }
      }
    },
    buildTermUrl(url) {
      const _url = new URL(url);
      const hasLangParam = _url.searchParams.has('lang');
      const [success_url, failure_url] = this.buildRedirectionURL(this.purchase.reference);
      return `${url}${hasLangParam ? '&' : '?'}success_url=${success_url}&failure_url=${failure_url}&redirection_domain=${process.env.VUE_APP_REDIRECTION_DOMAIN}`;
    },
    _showPaymentError() {
      var errorMessage =
        typeof this.$store.state.payment.detail !== 'undefined' &&
        this.$store.state.payment.detail.error_message
          ? this.$store.state.payment.detail.error_message
          : this.$t('payment.error')

      var errorCode =
        typeof this.$store.state.payment.detail !== 'undefined' &&
        this.$store.state.payment.detail.error_code
          ? this.$store.state.payment.detail.error_code
          : 'undefined'

      if (typeof CustomEvent === 'function') {
        var event = new CustomEvent('showError', {
          detail: {
            text: errorMessage,
            errorCode: errorCode
          }
        })
        window.dispatchEvent(event)
      }
    },
    _formPost(path, params, method = 'post') {
      // The rest of this code assumes you are not using a library.
      // It can be made less wordy if you use one.
      const form = document.createElement('form')
      form.method = method
      form.action = path
      for (const key in params) {
        if (params[key]) {
          const hiddenField = document.createElement('input')
          hiddenField.type = 'hidden'
          hiddenField.name = key
          hiddenField.value = params[key]

          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
    },
    _addInsurance(insuranceData, insured) {
      this.thereIsInsurance = true
      this.insuranceData = Object.assign({}, insuranceData, {
        insured: insured
      })
    },
    _manageInsurance(response) {
      this.insuranceData.id_card_type = 'nif'
      var query = {
        details: this.paymentData.details,
        policy: this.insuranceData
      }
      this.$store.dispatch('payment/createInsurance', query)
    },
    _managePaymentMethods() {
      if(this.$store.state.payment.methods.three_ds) {
        this.type = 'three_ds'
      } else if (this.$store.state.payment.methods.stripe) {
        this.type = 'stripe'
        if(this.$store.state.payment.methods.stripe_3ds) {
          this.type = 'stripe_3ds'
        }
        this.noSaveCard = true
        this.addNewCard = true
      }
      if (this.$store.state.payment.methods.stripe_fallback) {
        this.noSaveCard = true
      }
      if (this.$store.state.user.cards.length === 0) this.addNewCard = true
      if (this.$ua.deviceType() !== 'pc') {
        if (
          typeof this.$store.state.telecoming.carrier.complete_url ===
          'undefined' &&
          window.canRunAds
        ) {
          this.showTelecoming = true
        }
      }
    },
    _formatTickets() {
      let ticketsAux = this.$store.state.purchase.detail.tickets
      ticketsAux.forEach(ticket => {
        if (!this.ticketsDetail[ticket.ticket_type]) {
          this.ticketsDetail[ticket.ticket_type] = this.ticketsDetail[
            ticket.ticket_type
          ]
            ? this.ticketsDetail[ticket.ticket_type]
            : {}
          this.ticketsDetail[ticket.ticket_type] = {
            quantity: 1,
            title: ticket.title,
            price: parseFloat(ticket.price)
          }
        } else {
          this.ticketsDetail[ticket.ticket_type].quantity =
            this.ticketsDetail[ticket.ticket_type].quantity + 1
        }
      })
    }
  }
}
</script>
